import React from "react";
import classNames from "classnames";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import APPCONFIG from "constants/Config";

export default class Users extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Admins_Users._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	handleLoginAs = async (e) => {
		const user = parseInt(e.currentTarget.id);
		const binary_id = e.currentTarget.getAttribute('binary_id');
		const account = e.currentTarget.getAttribute('account');

		this.setState({loading: true});

		let dpModel = new API.BuildClass(Types.Admins_Users._name, API.RequestType.READ);
		dpModel.parent = account;

		dpModel.object.pkey = user;
		dpModel.object.binary_id = binary_id;

		try {
			await dpModel.submit(null, API.RequestType.UPDATE, false, false, false, true);
			this.setState({loading: false});
			window.location = APPCONFIG.settings.appURL();
		} catch (e) {
			this.setState({loading: false});
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Users')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}><i
										className={"fa fa-refresh"}/></Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "",
									className: "button-cell",
									filterable: false,
									sortable: false,
									width: 85,
									Cell: props => {
										return (
											<span>
												<Button
													id={props.original.pkey}
													binary_id={props.original.binary_id}
													account={props.original.accounts.pkey}
													color="green-meadow"
													size={"sm"}
													block={true}
													onClick={this.handleLoginAs}>
													<i className={"fa fa-lock"}/> Login As
												</Button>
											</span>
										);
									}
								},
								{
									Header: "Company",
									id: "name_company",
									accessor: obj => obj.accounts.name_company,
								},
								{
									Header: "First",
									id: "name_first",
									accessor: obj => obj.name_first,
								},
								{
									Header: "Last",
									id: "name_last",
									accessor: obj => obj.name_last,
								},
								{
									Header: "Email",
									id: "email",
									accessor: obj => obj.email,
								},
								{
									Header: "Location",
									id: "location",
									accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "All Locations")
								},
								{
									Header: "Access",
									id: "access",
									/** @param {Users_Object} obj */
									accessor: obj => obj.user_accesses.name,
								},
								{
									Header: "Account",
									id: "account",
									/** @param {Accounts_Object} obj */
									accessor: obj => obj.accounts.pkey,
								},
								{
									Header: "Owner",
									id: "owner",
									accessor: obj => obj.accounts.name_first + " " + obj.accounts.name_last,
								},
								{
									Header: "Email",
									id: "account_email",
									accessor: obj => obj.accounts.email,
								},
							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}